import React, { createContext, useMemo } from "react";
import { User } from "types";

export interface AuthContextType {
  user: User;
  userRole: number;
  signOut: (callback?: VoidFunction) => void;
}

export const AuthContext = createContext<AuthContextType>(null as any);

export const AuthProvider = ({
  children,
  user,
  signOut,
}: {
  children: React.ReactNode;
  user: User;
  signOut: (callback?: VoidFunction) => void;
}) => {
  const value = useMemo(
    () => ({
      user,
      userRole: user?.role,
      signOut,
    }),
    [user, signOut],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
